<template>
    <div>
        <template>
        <modal
        name="auditTrailModal"
        classes="v-modal-sec linklca"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="1300px"
        height="auto"
        >
        <div class="v-modal">
        <div class="popup-header fromDetailsPage"> 
        <h2 class="popup-title">
          I-9 Audit Trail

        </h2>
        <div class="audit_trail_actions">
            <button  class="light-blue-btn primary-btn" @click="generatePdf()">Generate PDF</button>
            <span @click="$modal.hide('auditTrailModal');hideAudit()">
            <em class="material-icons">close</em>
            </span>
        </div>
        </div>
        <!-- <form data-vv-scope="newCaseNumberForm" @submit.prevent @keydown.enter.prevent> -->
          <div class="linklca_form">
            <!-- <div class=" linklca_form_header">
                <div class="search">
                </div>
                
            </div> -->
            <div class="form-container pad0 padb20">
                <div class="accordian-table auditTrail_table no-wrap relative">
                  
                    <NoDataFound ref="NoDataFoundRef" :loading="isListLoading" v-if="auditTrailList.length == 0" content=""
                    :heading="'No Results Found'" type='petitions' />
                    <template v-if="auditTrailList.length > 0">
                    <vs-table :data="auditTrailList">
                        <template v-if="auditTrailList.length > 0" slot="thead">     
                            <vs-th > Date Time </vs-th>
                            <vs-th> Name/Role </vs-th>
                            <vs-th > Location/IP</vs-th>
                            <vs-th> Title </vs-th>
                            <vs-th> Description </vs-th>
                        </template>
                        <template slot-scope="{ data }">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="vs-table--tr">
                                <vs-td>
                                    <div> {{ checkProperty(tr, 'createdOn') | formatDateTime }} </div>
                                </vs-td>
                                <vs-td class="td_label">
                                    <div>
                                    {{ checkProperty(tr, 'createdByName') }} <br />
                                    <small> {{ checkProperty(tr, 'createdByRoleName') }} </small>
                                    </div>
                                </vs-td>
                                <vs-td class="td_label">
                                    <div> 
                                        <template v-if="checkProperty(tr, 'ipInfo')">
                                            <template v-if="checkProperty(tr, 'ipInfo', 'country')">
                                                {{ checkProperty(tr, 'ipInfo', 'country') }} <br />
                                                <small v-if="checkProperty(tr, 'ipInfo', 'ip')"> {{ checkProperty(tr, 'ipInfo', 'ip') }} </small>
                                            </template>
                                            <template v-else>
                                                N/A
                                            </template>
                                        </template>
                                        <template v-else>  N/A </template>
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div> {{ checkProperty(tr, 'title')}} </div>
                                </vs-td>
                                <vs-td class="td_label">
                                    <div> {{ checkProperty(tr, 'description')}} </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                    </template>
                </div>            
            </div>
          </div>
        <!-- </form> -->
      </div>
        </modal>
        </template>
    </div>
 
</template>
<script>
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import * as _ from "lodash";
import { XIcon, MoreVerticalIcon } from 'vue-feather-icons'
import Vue from 'vue';
Vue.use(CKEditor);
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import NoDataFound from "@/views/common/noData.vue";

export default {
    methods: {
        psSectionScroll(){},
        hideAudit() {
            this.$modal.hide('auditTrailModal');
            this.$emit("hideAudit");
        },
        getTrailsList(){
            let PayLoad = {
                i9Id:this.i9Id,
                page:1,
                perpage:1000,
                auditTrail:true
            };
            let path = '/i9/activity-list';
            this.updateLoading(true);
            this.isListLoading = true;
            this.$store.dispatch('commonAction', {data:PayLoad, path:path}).then((res)=>{
                
                if(res.list){
                    this.auditTrailList = res.list;
                }
                this.isListLoading = false;
                this.updateLoading(false);
                setTimeout(() =>{
                    this.isListLoading = false;
                    this.updateLoading(false);
                })
            }).catch((err)=>{

            })
        },
        generatePdf(){
            let PayLoad = {
                i9Id:this.i9Id,
                page:1,
                perpage:1000,
                auditTrail:true
            };
            let path = '/i9/generate-activities-pdf';
            this.$store.dispatch('commonAction', {data:PayLoad, path:path}).then((res)=>{
                let path = null;
                if(res){
                    path = res;
                    this.downloads3file(path);
                    setTimeout(()=>{
                        this.hideAudit();
                    })
                }
                
            }).catch((err)=>{
                this.showToster({message:err, isError:true});
            })
        },
    },
    watch: {

    },
    mounted() {
        // this.updateLoading(false);
        // this.auditTrailList = [];
        // setTimeout(() =>{
        //     this.updateLoading(false);
        // })
        this.getTrailsList();
        this.$modal.show('auditTrailModal');
    },
    data: () => ({
        settings: { 
            swipeEasing: true,
        },
        isListLoading:false,
        auditTrailList: [],
    }),
    props: {
        i9Id:'',
        caseDetails:null,
    },
    components:{
        XIcon,
        NoDataFound,
        MoreVerticalIcon,
        VuePerfectScrollbar
    },
    computed:{
    }
};
</script>
  